import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a787168e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-div" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_5 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://i.imgur.com/uA3fRLZ.png",
    class: "image",
    alt: "logo"
  })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-justify-content-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Wait a moment please...", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("progress", { class: "progress is-primary" }, null, -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "is-flex is-flex-direction-column is-align-content-center"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-5 has-text-centered\" data-v-a787168e><span class=\"fa fa-times has-text-danger fa-6x\" data-v-a787168e></span></div><p class=\"is-size-5 has-text-centered\" data-v-a787168e> There was a problema validating your payment. </p><p class=\"has-text-grey has-text-centered\" data-v-a787168e> Contact our support at <a href=\"mailto:support@vetexpertise.com\" data-v-a787168e>support@vetexpertise.com</a></p>", 3)
const _hoisted_15 = [
  _hoisted_12
]
const _hoisted_16 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-check has-text-success fa-6x" }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: 3,
  class: "mt-5 has-text-centered"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "is-size-3" }, " Thank you! ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "is-size-5" }, " Your request has been sent to our specialist. ", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "has-text-grey" }, " We will confirm it as soon as possible and send you an email with instructions. ", -1))

import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {useStore} from "vuex";



const __default__ = {
  name: "RequestSent",
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const store = useStore()
const paymentHash = ref()
const validating = ref(true)
const hasError = ref(false)

onMounted(async () => {
  paymentHash.value = route.params.payment_hash

  /* validate payment */
  try {
    const validated = await store.dispatch('confirmPayment', paymentHash.value)

    /* turn off validation state */
    if (validated) {
      validating.value = false
    }/* turn off validation state */
    if (validated) {
      validating.value = false
    }
  } catch (e) {
    hasError.value = true
  }


})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (validating.value && !hasError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
              : _createCommentVNode("", true),
            (hasError.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
              : _createCommentVNode("", true),
            (!validating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
              : _createCommentVNode("", true),
            (!validating.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _hoisted_20,
                  _hoisted_21,
                  _hoisted_22,
                  _createVNode(_component_router_link, { to: "/meeting" })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})